// Global spacing values, based on a 8pt grid

const unit = 8;
const xs = 0.5 * unit + "px"; // 4px
const sm = unit + "px"; // 8px
const md = unit * 2 + "px"; // 16px
const lg = unit * 3 + "px"; // 24px
const xl = unit * 6 + "px"; // 48px
const xxl = unit * 8 + "px"; // 64px

const Spacing = {
  xs,
  sm,
  md,
  lg,
  xl,
  xxl,
};

export default Spacing;
